/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    InvestownMetaDataDto,
    InvestownMetaDataDtoFromJSON,
    InvestownMetaDataDtoFromJSONTyped,
    InvestownMetaDataDtoToJSON,
} from './InvestownMetaDataDto';
import {
    SavingsAccountMetaDataDto,
    SavingsAccountMetaDataDtoFromJSON,
    SavingsAccountMetaDataDtoFromJSONTyped,
    SavingsAccountMetaDataDtoToJSON,
} from './SavingsAccountMetaDataDto';

/**
 * 
 * @export
 * @interface PersonalAssetMetaDataDto
 */
export interface PersonalAssetMetaDataDto {
    /**
     * 
     * @type {SavingsAccountMetaDataDto}
     * @memberof PersonalAssetMetaDataDto
     */
    savingsAccount?: SavingsAccountMetaDataDto;
    /**
     * 
     * @type {InvestownMetaDataDto}
     * @memberof PersonalAssetMetaDataDto
     */
    investown?: InvestownMetaDataDto;
}

export function PersonalAssetMetaDataDtoFromJSON(json: any): PersonalAssetMetaDataDto {
    return PersonalAssetMetaDataDtoFromJSONTyped(json, false);
}

export function PersonalAssetMetaDataDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PersonalAssetMetaDataDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'savingsAccount': !exists(json, 'savingsAccount') ? undefined : SavingsAccountMetaDataDtoFromJSON(json['savingsAccount']),
        'investown': !exists(json, 'investown') ? undefined : InvestownMetaDataDtoFromJSON(json['investown']),
    };
}

export function PersonalAssetMetaDataDtoToJSON(value?: PersonalAssetMetaDataDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'savingsAccount': SavingsAccountMetaDataDtoToJSON(value.savingsAccount),
        'investown': InvestownMetaDataDtoToJSON(value.investown),
    };
}

